<div *ngIf="router?.url != '/sign-up' && router?.url != '/login' && router?.url != '/thank-you' && router?.url != '/not-found' && router?.url != '/maintenance'">
	<!-- Footer section 2 -->
	<!-- <div *ngIf="router?.url != '/home'" angly-subscribe [subscribeFormClasses]="subscribeFormClasses"></div> -->
	<div angly-footerLogoList [logoList]="footerLogo" class="client-logo"></div>
	
	<!-- Back To Top -->
	<a href="#" id="back-top" class="to-top scrolled" (click)="topScroll($event)"> <span class="to-top-icon"></span> </a>
</div>
